export default __webpack_public_path__ + "static/media/9.7b38c407.jpg";